import React from 'react';
import {connect} from 'react-redux';
import Store from './store';
import {getStaffRewardOutlet} from '../../actions/staff';
import ManageRewards from './manage-rewards';

const StoreList = (props) => {

    const onManageClicked = (storeId, row) => {
        props.dispatch(getStaffRewardOutlet(storeId, row));
    }

    let storeItems = [<h1>Loading...</h1>];
    if (props.fetched) {
        storeItems = [[]];
        props.stores.forEach((store, index) => {
            if(index > 0 && !(index % 3)){
                storeItems.push([]);
            }
            storeItems[storeItems.length - 1].push(
                <Store key={store.id}
                       row={storeItems.length - 1}
                       open={props.manageStoreId === store.id}
                       store={store}
                       onManageClicked={onManageClicked}
                />
            );
        });
    }

    return (
        <div className="staff-rewards-store-list">
            {storeItems.map((store, index) => {
                return (
                    <div key={`container-${index}`}>
                        <div className="row manage-staff-rewards-row" key={`row-${index}`}>
                            {store}
                        </div>
                        <div className="row manage-staff-rewards-row" key={`edit-${index}`}>
                            {index === props.manageRow && <ManageRewards open={index === props.manageRow} />}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        manageRewardsVisible: state.staff.staffRewards.manageRewardsVisible,
        manageRow: state.staff.staffRewards.manageRow,
        manageStoreId: state.staff.staffRewards.manageStoreId
    }
};

export default connect(mapStateToProps)(StoreList);



// WEBPACK FOOTER //
// ./src/components/staff-rewards/store-list.jsx